import { atom } from "jotai";
import { WebSocketClient } from "@/model";

export const connectUsersAtom = atom<WebSocketClient[]>([]);
